export const USAGE_REPORT_REQUEST = "USAGE_REPORT_REQUEST"
export const USAGE_REPORT_SUCCESS = "USAGE_REPORT_SUCCESS"
export const USAGE_REPORT_FAILED = "USAGE_REPORT_FAILED" 

export const GetUsageReportAction = (data: any) => {
  return {
      type: USAGE_REPORT_REQUEST,
      payload: data
  }
}